import { groupBy } from '../../../utils/collections';
import { NavLink, useParams } from 'react-router-dom';
import { LayeredImage } from 'components/Images/LayeredImage/LayeredImage';
import './Index.scss';
import { useUser } from '../../../context/UserContext';
import MarketingItem from '../Components/MarketingItem';
//import { SocialMediaIndex } from '../Components/SocialMediaLibraryIndex';
import ImagePageTitle from '../../../components/common/image-page-title/ImagePageTitle';
import React from 'react';

export function MItem() {
  let { item } = useParams();

  /*if (item === 'SocialMediaLibrary') {
        return (
            <SocialMediaIndex item={item}/>
        )
    }*/

  return <MarketingItem item={item} />;
}

function CategorizeArray(data) {
  const grouped = groupBy(data, 'Category');
  const temp = Object.entries(grouped).map(([name, group]) => ({
    name,
    children: group.map(({ Title, Link, LinkTypeID }) => ({ Title, Link, LinkTypeID })),
  }));
  return temp;
}

function Index() {
  const user = useUser();
  const digitalAdvertisingFlag = process.env.REACT_APP_SM_FEATURE_FLAG !== 'OFF';
  //const producerClaim = useProducerClaim();
  /*useEffect(() => {}, [producerClaim]);
    if (producerClaim == null) {
      return null;
    }*/

  if (user == null) return null;

  return (
    <div id="training-root">
      <div id="page-navigation">
        <NavLink
          to="/Marketing"
          className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}
        >
          <div className="image-navigation-image">
            <ImagePageTitle image="/images/Learning Center Image.png" title="Marketing" />
          </div>
        </NavLink>
        {/*digitalAdvertisingFlag && <NavLink to="/Marketing/SocialMediaLibrary" className="image-navigation-item"
                                                    className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}>
                    <div className="image-navigation-image">
                        <ImagePageTitle image="/images/Learning Center Image.png" title="Digital Advertising"/>
                    </div>
                </NavLink>*/}
        {(user.division === 'CASG' || user.isHO) && (
          <>
            <NavLink
              to="/Marketing/PromotionalItems"
              className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}
            >
              <div className="image-navigation-image">
                <ImagePageTitle image="/images/promoitems.png" title="Promotional Items" />
              </div>
            </NavLink>
          </>
        )}
      </div>
    </div>
  );
}

export { Index };
